export enum EBannerType {
  DealSale,
  MortgageBroker,
  RentRaffle2024,
}
